import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  style: {"padding":"10px"},
  "data-testid": "log-viewer-settings-form"
}
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "checkbox" }
const _hoisted_5 = { class: "checkbox" }
const _hoisted_6 = { class: "checkbox" }
const _hoisted_7 = { class: "checkbox" }
const _hoisted_8 = { class: "checkbox" }
const _hoisted_9 = { class: "checkbox" }
const _hoisted_10 = { class: "checkbox" }
const _hoisted_11 = {
  ref: "log",
  class: "execution-log__scroller-item-container"
}
const _hoisted_12 = {
  key: 0,
  class: "execution-log__settings",
  style: {"margin-left":"5px","margin-right":"5px"},
  "data-testid": "log-viewer-toolbar"
}
const _hoisted_13 = {
  key: 0,
  class: "execution-log__progress-bar",
  "data-testid": "log-viewer-progress-bar"
}
const _hoisted_14 = {
  key: 1,
  class: "execution-log__warning",
  "data-testid": "log-viewer-oversize-warning"
}
const _hoisted_15 = {
  key: 2,
  class: "execution-log__warning",
  "data-testid": "log-viewer-error-message"
}
const _hoisted_16 = {
  key: 3,
  class: "execution-log__warning",
  "data-testid": "log-viewer-no-output"
}
const _hoisted_17 = {
  key: 0,
  class: "stats",
  "data-testid": "log-viewer-stats"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_socket = _resolveComponent("ui-socket")!
  const _component_RdDrawer = _resolveComponent("RdDrawer")!
  const _component_btn = _resolveComponent("btn")!
  const _component_btn_group = _resolveComponent("btn-group")!
  const _component_progress_bar = _resolveComponent("progress-bar")!
  const _component_LogNodeChunk = _resolveComponent("LogNodeChunk")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "root",
    class: _normalizeClass(["execution-log", [`execution-log--${_ctx.colorTheme}`]]),
    "data-testid": "log-viewer"
  }, [
    _createVNode(_component_RdDrawer, {
      title: "Settings",
      placement: "left",
      mask: false,
      visible: _ctx.settingsVisible,
      closable: true,
      "get-container": false,
      "wrap-style": { position: 'absolute' },
      onClose: _ctx.closeSettings
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[10] || (_cache[10] = _createElementVNode("label", null, "Theme", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.settings.theme) = $event)),
              class: "form-control select",
              "data-testid": "log-viewer-theme-select"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.themes, (themeOpt) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: themeOpt.value,
                  value: themeOpt.value
                }, _toDisplayString(themeOpt.label), 9, _hoisted_3))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.settings.theme]
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              id: "logview_gutter",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.settings.gutter) = $event)),
              type: "checkbox"
            }, null, 512), [
              [_vModelCheckbox, _ctx.settings.gutter]
            ]),
            _cache[11] || (_cache[11] = _createElementVNode("label", { for: "logview_gutter" }, "Display Gutter", -1))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              id: "logview_timestamps",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.settings.timestamps) = $event)),
              type: "checkbox"
            }, null, 512), [
              [_vModelCheckbox, _ctx.settings.timestamps]
            ]),
            _cache[12] || (_cache[12] = _createElementVNode("label", { for: "logview_timestamps" }, "Display Timestamps", -1))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              id: "logview_command",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.settings.command) = $event)),
              type: "checkbox"
            }, null, 512), [
              [_vModelCheckbox, _ctx.settings.command]
            ]),
            _cache[13] || (_cache[13] = _createElementVNode("label", { for: "logview_command" }, "Display Command", -1))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              id: "logview_nodeBadge",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.settings.nodeBadge) = $event)),
              type: "checkbox"
            }, null, 512), [
              [_vModelCheckbox, _ctx.settings.nodeBadge]
            ]),
            _cache[14] || (_cache[14] = _createElementVNode("label", { for: "logview_nodeBadge" }, "Display Node Badge", -1))
          ]),
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              id: "logview_ansiColor",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.settings.ansiColor) = $event)),
              type: "checkbox"
            }, null, 512), [
              [_vModelCheckbox, _ctx.settings.ansiColor]
            ]),
            _cache[15] || (_cache[15] = _createElementVNode("label", { for: "logview_ansiColor" }, "Render ANSI Colors", -1))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              id: "logview_lineWrap",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.settings.lineWrap) = $event)),
              type: "checkbox"
            }, null, 512), [
              [_vModelCheckbox, _ctx.settings.lineWrap]
            ]),
            _cache[16] || (_cache[16] = _createElementVNode("label", { for: "logview_lineWrap" }, "Wrap Long Lines", -1))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              id: "logview_stats",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.settings.stats) = $event)),
              type: "checkbox",
              "data-testid": "log-viewer-stats-checkbox"
            }, null, 512), [
              [_vModelCheckbox, _ctx.settings.stats]
            ]),
            _cache[17] || (_cache[17] = _createElementVNode("label", { for: "logview_stats" }, "Display Stats", -1))
          ]),
          _createVNode(_component_ui_socket, {
            section: "execution-log-viewer",
            location: "settings",
            "event-bus": _ctx.eventBus
          }, null, 8, ["event-bus"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onClose"]),
    _createElementVNode("div", {
      ref: "scroller",
      class: _normalizeClass(["execution-log__scroller", {
        'execution-log--no-transition': _ctx.logLines > 1000,
        'ansicolor-on': _ctx.settings.ansiColor,
      }]),
      style: _normalizeStyle(_ctx.node ? { height: '600px', flex: 'none', overflowY: 'hidden' } : {})
    }, [
      _createElementVNode("div", _hoisted_11, [
        (_ctx.showSettings)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_btn_group, null, {
                default: _withCtx(() => [
                  _createVNode(_component_btn, {
                    size: "xs",
                    "data-testid": "log-viewer-settings-btn",
                    onClick: _ctx.toggleSettings
                  }, {
                    default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                      _createElementVNode("i", { class: "fas fa-cog" }, null, -1),
                      _createTextVNode("Settings ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_btn, {
                    size: "xs",
                    "data-testid": "log-viewer-follow-btn",
                    onClick: _ctx.toggleFollow
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("i", {
                        class: _normalizeClass([_ctx.followIcon]),
                        "data-testid": "log-viewer-follow-icon"
                      }, null, 2),
                      _cache[19] || (_cache[19] = _createTextVNode("Follow ", -1))
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  (_ctx.showProgress)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createVNode(_component_progress_bar, {
                          modelValue: _ctx.barProgress,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.barProgress) = $event)),
                          type: _ctx.progressType,
                          "label-text": _ctx.progressText,
                          label: "",
                          "min-width": "",
                          striped: "",
                          active: "",
                          "data-testid": "log-viewer-progress-bar-component",
                          onClick: _ctx.toggleProgressBar
                        }, null, 8, ["modelValue", "type", "label-text", "onClick"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.overSize)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("h3", null, " 🐋 " + _toDisplayString(+(_ctx.logSize / 1048576).toFixed(2)) + "MiB is a whale of a log! 🐋 ", 1),
              _cache[20] || (_cache[20] = _createElementVNode("h4", null, "Select a download option above to avoid sinking the ship.", -1)),
              _cache[21] || (_cache[21] = _createElementVNode("h5", null, "Log content may be truncated", -1))
            ]))
          : _createCommentVNode("", true),
        (_ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("h4", null, _toDisplayString(_ctx.errorMessage), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.completed && _ctx.logLines === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [...(_cache[22] || (_cache[22] = [
              _createElementVNode("h5", null, "No output", -1)
            ]))]))
          : _createCommentVNode("", true),
        (!_ctx.overSize)
          ? (_openBlock(), _createBlock(_component_LogNodeChunk, {
              key: 4,
              ref: "logEntryChunk",
              class: "execution-log__node-chunk",
              "event-bus": _ctx.eventBus,
              "selected-line": _ctx.selectedLineIdx,
              node: _ctx.node,
              "step-ctx": _ctx.stepCtx,
              "node-icon": _ctx.settings.nodeBadge,
              "max-line": 2000,
              command: _ctx.settings.command,
              time: _ctx.settings.timestamps,
              gutter: _ctx.settings.gutter,
              "line-wrap": _ctx.settings.lineWrap,
              entries: _ctx.viewerEntries,
              "jump-to-line": _ctx.jumpToLine,
              jumped: _ctx.jumped,
              follow: _ctx.mfollow,
              onLineSelect: _ctx.handleLineSelect,
              onJumped: _cache[9] || (_cache[9] = ($event: any) => (_ctx.jumped = true)),
              onFollowChange: _ctx.onNodeFollowChange
            }, null, 8, ["event-bus", "selected-line", "node", "step-ctx", "node-icon", "command", "time", "gutter", "line-wrap", "entries", "jump-to-line", "jumped", "follow", "onLineSelect", "onFollowChange"]))
          : _createCommentVNode("", true)
      ], 512)
    ], 6),
    (_ctx.settings.stats)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("span", null, "Following:" + _toDisplayString(_ctx.mfollow) + " Lines:" + _toDisplayString(_ctx.logLines.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")) + " Size:" + _toDisplayString(_ctx.logSize) + "b TotalTime:" + _toDisplayString(_ctx.totalTime / 1000) + "s", 1)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}